import { ALL_USER_ROLES, USER_ROLES } from "@/consts";

const accessRoles = [USER_ROLES.CLIENT_AGENT];

export default {
  path: "sa",
  component: (resolve) => require(["@/views/SA/Index"], resolve),
  name: "SAIndex",
  children: [
    {
      path: "select-order-type",
      component: () =>
        import(/* webpackChunkName: "sa-create" */ "@/views/SA/SelectType"),
      name: "SASelectOrdertype",
      meta: {
        title: "选择类型",
        accessRoles: ALL_USER_ROLES,
        withTabbar: false,
      },
    },
    {
      path: "create-order",
      component: () =>
        import(/* webpackChunkName: "sa-create" */ "@/views/SA/Create"),
      name: "SACreateOrder",
      meta: {
        title: "创建订单",
        accessRoles: ALL_USER_ROLES,
        withTabbar: false,
      },
    },
    {
      path: "share-order",
      component: () =>
        import(/* webpackChunkName: "sa-create" */ "@/views/SA/Share"),
      name: "SAShareOrder",
      meta: { accessRoles: ALL_USER_ROLES, withTabbar: false },
    },
    {
      path: "order",
      component: () =>
        import(/* webpackChunkName: "order" */ "@/views/SA/Order"),
      name: "Order",
      meta: {
        title: "远程销售",
        accessRoles: ALL_USER_ROLES,
        withTabbar: false,
      },
    },
    {
      path: "dashboard",
      component: () =>
        import(/* webpackChunkName: "sa-dashboard" */ "@/views/SA/Dashboard"),
      name: "SADashboard",
      meta: {
        title: "我的业绩",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "customers",
      component: () =>
        import(/* webpackChunkName: "sa-customers" */ "@/views/SA/Customers"),
      name: "SACustomers",
      meta: {
        title: "我的顾客",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "orders",
      component: () =>
        import(/* webpackChunkName: "sa-orders" */ "@/views/SA/Orders"),
      name: "SAOrders",
      meta: {
        title: "全部订单",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
    {
      path: "my",
      component: () =>
        import(/* webpackChunkName: "sa-my" */ "@/views/SA/Mine"),
      name: "SAMy",
      meta: {
        title: "我的",
        accessRoles,
        storeSelectable: true,
        withTabbar: true,
      },
    },
  ],
};
